import { Injectable } from '@angular/core';
import { AsyncValidatorFn, ValidatorFn, Validators } from '@angular/forms';
import { FormControlEx } from './../../component/forms/form-control';

@Injectable()
export class FormControlExFactory {
  constructor() {}

  create(
    caption: string,
    state: any,
    validator?: ValidatorFn | ValidatorFn[] | null,
    asyncValidator?: AsyncValidatorFn | null,
    helpText?: string
  ): FormControlEx {
    return new FormControlEx(caption, state, validator, asyncValidator, helpText);
  }

  createEmail(caption: string, state: any, helpText?: string): FormControlEx {
    return this.create(caption, state, Validators.email, null, helpText);
  }

  createEmailMandatory(caption: string, state: any, helpText?: string): FormControlEx {
    let model = this.create(caption, state, Validators.email, null, helpText);
    model.required = true;
    return model;
  }

  createHidden(state?: any): FormControlEx {
    return this.create('', state);
  }

  createMandatory(caption: string, state: any, helpText?: string): FormControlEx {
    let model = this.create(caption, state, null, null, helpText);
    model.required = true;
    return model;
  }

  createMaxLength(caption: string, state: any, maxLength: number, helpText?: string) {
    let model = this.create(caption, state, Validators.maxLength(maxLength), null, helpText);
    model.maxLength = maxLength;
    return model;
  }

  createReadonly(caption: string, state: any, helpText?: string): FormControlEx {
    let model = this.create(caption, state, null, null, helpText);
    model.isReadonly = true;
    return model;
  }

  createWithOptions(
    caption: string,
    state: any,
    options: {
      isReadonly?: boolean;
      length?: number;
      maxValue?: number;
      minValue?: number;
      required?: boolean;
      validator?: ValidatorFn;
      asyncValidator?: AsyncValidatorFn;
      helpText?: string;
      noSubmit?: boolean;
    }
  ): FormControlEx {
    let validators = options.validator ? [options.validator] : [];

    if (options.length) {
      validators.push(Validators.maxLength(options.length));
    }

    if (options.maxValue) {
      validators.push(Validators.max(options.maxValue));
    }

    if (options.minValue) {
      validators.push(Validators.min(options.minValue));
    }

    // `FormControlEx.required` owns this validator so conditional required-state
    // changes can remove it again without rebuilding from a stale validator list.
    const control = this.create(caption, state, validators, options.asyncValidator, options.helpText);
    control.isReadonly = options.isReadonly;
    control.maxLength = options.length;
    control.required = options.required;
    control.noSubmit = options.noSubmit;
    return control;
  }
}
